import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityStatusSlice } from './get';
import { postCoreDataSecurityStatusSlice } from './post';

export const coreDataSecurityStatusReducers = combineReducers({
	get: getCoreDataSecurityStatusSlice.asyncReducers,
	post: postCoreDataSecurityStatusSlice.asyncReducers
});

export const coreDataSecurityStatusWatchers = combineAllWatchers(
	[
		getCoreDataSecurityStatusSlice.asyncWatchers,
		postCoreDataSecurityStatusSlice.asyncWatchers
	]
);
